export class SummaryPdfNameComponents {
  projectName: string;
  respondentName: string;
  responseDate: string;
}
